// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { ResponseMessageSchema, StatusSchema } from "./utilitySchemas";
import { EntitySchema } from "./entitySchemas";

export const AppraiserQuerySchema = z.object({
	limit: z.coerce.number().int().positive().optional(),
	offset: z.coerce.number().int().nonnegative().optional(),
	sortBy: z
		.enum(["id", "createdAt", "updatedAt"])
		.optional(),
	sortOrder: z.enum(["asc", "desc"]).optional(),
});

export type AppraiserQuery = z.infer<typeof AppraiserQuerySchema>;

export const AppraiserSchema = z.object({
	id:z.string(),
	name: z.string(),
	identifier: z.string(),
	entityName: z.string(),
	createdAt: z.date(),
	updatedAt: z.date(),
	evalionId: z.string(),
	entity:EntitySchema.nullable(),
	_count: z.object({
		companies: z.number(),
		users: z.number(),
	}),
});

export type Appraiser = z.infer<typeof AppraiserSchema>;

export const GetAppraisersResponseSchema = z.object({
  status: StatusSchema,
  message: ResponseMessageSchema,
  data: z.array(AppraiserSchema),
});

export const GetAppraiserResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: AppraiserSchema,
});

export const updateAppraiserEmailInfoSchema = z.object({
	supportEmail: z.string(),
	postMarkApiKey: z.string(),
});

export type UpdateAppraiserEmailInfo = z.infer<
	typeof updateAppraiserEmailInfoSchema
	>;

export const updateAppraiserPaymentInfoSchema = z.object({
	platformFeeInvoiceRecipients: z.string(),
	paymentInvoiceRecipients: z.string(),
	managingDirector: z.string(),
	commercialRegister: z.string(),
	taxNumber: z.string(),
	companyAddress: z.string(),
	companyName: z.string(),
	vatIdNumber: z.string(),
	supportEmail: z.string(),
});

export type UpdateAppraiserPaymentInfo = z.infer<
	typeof updateAppraiserPaymentInfoSchema
>;
